import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SalesLetterSection } from './components/SalesLetterSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UrgentCTA } from './components/UrgentCTA';
export function App() {
  return <div className="min-h-screen w-full bg-amber-50" data-id="element-0">
      <StickyAlertBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPointsSection data-id="element-4" />
        <SalesLetterSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingCard data-id="element-8" />
        <TestimonialsSection data-id="element-9" />

        {/* Final CTA Section */}
        <section className="bg-gradient-to-b from-white to-pink-50 py-12 md:py-16 px-4" data-id="element-10">
          <div className="container mx-auto max-w-3xl text-center" data-id="element-11">
            <h2 className="text-3xl md:text-5xl font-extrabold text-pink-600 mb-6 leading-tight" data-id="element-12">
              🔥 ACCESO INMEDIATO - OFERTA POR TIEMPO LIMITADO 🔥
            </h2>
            <p className="text-lg md:text-2xl text-stone-700 mb-8 font-bold" data-id="element-13">
              La decisión es tuya. Pero el tiempo se acaba.
            </p>
            <UrgentCTA size="large" data-id="element-14">SÍ, QUIERO EMPEZAR AHORA</UrgentCTA>

            <div className="mt-8 space-y-2" data-id="element-15">
              <p className="text-base md:text-lg text-pink-600 font-bold" data-id="element-16">
                ✓ Acceso inmediato al curso completo
              </p>
              <p className="text-base md:text-lg text-pink-600 font-bold" data-id="element-17">
                ✓ Todos los bonos incluidos
              </p>
              <p className="text-base md:text-lg text-pink-600 font-bold" data-id="element-18">
                ✓ Soporte 24/7
              </p>
              <p className="text-base md:text-lg text-pink-600 font-bold" data-id="element-19">
                ✓ Resultados en menos de 24 horas
              </p>
            </div>

            <p className="text-sm md:text-base text-rose-500 mt-8 font-extrabold uppercase animate-flash" data-id="element-20">
              ⚠️ P.D. Recordá: esta oferta de $18,999 vence en 10 minutos.
              Después vuelve al precio normal de $52,000.
            </p>
            <p className="text-base md:text-lg text-pink-600 font-bold mt-4" data-id="element-21">
              No dejes pasar esta oportunidad de cambiar tu situación económica.
              Hacé click ahora y empezá HOY.
            </p>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-white py-8 px-4 border-t border-pink-200" data-id="element-22">
          <div className="container mx-auto max-w-4xl text-center" data-id="element-23">
            <p className="text-stone-600 text-sm md:text-base mb-2" data-id="element-24">
              © 2026 Todos los derechos reservados
            </p>
            <p className="text-stone-500 text-xs md:text-sm" data-id="element-25">
              Pago seguro • Soporte 24/7
            </p>
          </div>
        </footer>
      </main>
    </div>;
}